module.exports = __webpack_public_path__ + "img/ziyouwangguo2.f674ac46.jpg";